import "./App.css"
import Weather from "./components/Weather/Weather"

function App(): JSX.Element {
  return (
    <div className='App'>
      <Weather />
    </div>
  )
}

export default App
